import React, { useContext } from "react";
import LeadDetailReadOnlyContext from "contexts/LeadDetailReadOnlyContext";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import PropTypes from 'prop-types';
import { useState } from "react";
import NumberFormat from "react-number-format";
import PositiveInput from "../PositiveInput";
import { SfCommaStringFormatter, SfDollarStringFormatter, getPrimaryButtonClass } from "helpers/sf_utils";
import { phoneNumberFormatter } from "pages/Admin/Users/UserComponents/UserList/Formatters";

const LeadEditDropdownForNumberFields = props => {
    const isReadOnly = useContext(LeadDetailReadOnlyContext) || props?.isReadOnly;
    const [fieldInput, setFieldInput] = useState(props.field);
    const [isOpen, setIsOpen] = useState(false)
    const [isMouseDown, setIsMouseDown] = useState(false)

    const [isEditable, setIsEditable] = useState(false)

    const toggle = () => setIsOpen(!isOpen);

    const handleOnClickClose = () => {
        setIsOpen(false);
    };

    const displayValue = props?.commaFormatter
        ? SfCommaStringFormatter(props?.field)
        : props?.dollarFormatter
            ? SfDollarStringFormatter(props?.field)
            : props?.isPhoneNumber
                ? phoneNumberFormatter(props.field)
                : props?.field ? props?.field : "--";

    if (isReadOnly) {
        return <p className="mb-0 fsnormal text-black me-1">{displayValue}</p>;
    }

    return (
        <React.Fragment>
            <UncontrolledDropdown isOpen={isOpen}
                onToggle={(event, isOpen) => {
                    if (!isMouseDown && isOpen) {
                        toggle()
                    } else if (isMouseDown && isOpen) {
                        setIsMouseDown(false);
                    }
                    else if (!isOpen) {
                        setIsMouseDown(false);
                        setIsOpen(true)
                    }
                }}
                onMouseDown={(e) => setIsMouseDown(true)}
                onMouseUp={(e) => setIsMouseDown(false)}>
                <DropdownToggle
                    href="#"
                    className='nav-link py-0 px-0'
                    tag="i"
                >
                    <div 
                        className="d-flex" 
                        onMouseEnter={(e) => {
                            setIsEditable(true);
                        }}
                        onMouseLeave={(e) => {
                            setIsEditable(false);
                        }}
                    >
                        <p className="mb-0 fsnormal text-black me-1" onMouseEnter={(e) => {setIsEditable(true)}} onMouseLeave={(e) => {setIsEditable(false)}}>
                            {props?.commaFormatter ?
                                SfCommaStringFormatter(props?.field)
                                :
                                props?.dollarFormatter ? SfDollarStringFormatter(props?.field)
                                :
                                props?.isPhoneNumber ? phoneNumberFormatter(props.field)
                                :
                            props?.field ? props?.field : "--"
                            }
                        </p>
                        {isEditable === true ?
                            <i
                                className="font-size-13 mdi mdi-pencil text-success"
                            /> :
                            <div className="edit-hover-class">
                                <a ><i
                                    className="font-size-13 mdi mdi-pencil text-success"
                                />
                                </a>
                            </div>
                        }
                    </div>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-start">
                    <DropdownItem className="font-weight-semibold">{props?.title}</DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem text>
                        <div className="d-flex flex-column">
                            {props.noThousandSeparator ?
                                <div>
                                    <NumberFormat
                                        className="form-control sf-box-w"
                                        value={fieldInput}
                                        autoFocus={true}
                                        onChange={(e) => {
                                            e.persist();
                                            const value = parseInt(e.target?.value?.replace(",", ""))
                                            setFieldInput(value);
                                        }}
                                    />
                                </div>
                                :
                                props.dollarFormatter ? 
                                <div>
                                    <NumberFormat
                                        className="form-control sf-box-w"
                                        prefix="$"
                                        thousandSeparator
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        value={fieldInput}
                                        autoFocus={true}
                                        onValueChange={(values) => {
                                            const {value} = values;
                                            setFieldInput(value)
                                        }}
                                    />
                                </div>
                                :
                                props.isPhoneNumber ? 
                                <div>
                                    <NumberFormat
                                        className="form-control sf-box-w"
                                        format="###-###-####"
                                        type="text"
                                        mask="_"
                                        value={fieldInput}
                                        onChange={(e) => {
                                            e.persist();
                                            const value = parseInt(e.target?.value?.replace(/[^0-9]/g, ""))
                                            setFieldInput(value);
                                        }}
                                        />
                                </div>
                                :
                                <div>
                                    <PositiveInput
                                        className="form-control sf-box-w"
                                        thousandSeparator
                                        value={fieldInput}
                                        autoFocus={true}
                                        onChange={(e) => {
                                            e.persist();
                                            const value = parseInt(e.target?.value?.replace(",", ""))
                                            setFieldInput(value);
                                        }}
                                    />
                                </div>
                            }
                            <div className="d-flex align-items-center ms-auto mt-2">
                                <button
                                    className={`btn btn-sm ${getPrimaryButtonClass()} mx-1`}
                                    name="saveName"
                                    onClick={() => {
                                        props.onSave(fieldInput)
                                        handleOnClickClose()
                                    }}
                                >
                                    Save
                                </button>
                                <button className="btn btn-sm btn-light mx-1" name="resetName" onClick={handleOnClickClose}>Cancel</button>
                            </div>
                        </div>
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        </React.Fragment>
    )
}

LeadEditDropdownForNumberFields.propTypes = {
    title: PropTypes.any,
    field: PropTypes.string,
    onSave: PropTypes.func,
    onCancel: PropTypes.func,
    options: PropTypes.array,
    noThousandSeparator: PropTypes.bool,
    commaFormatter : PropTypes.bool,
    dollarFormatter: PropTypes.bool,
    isPhoneNumber: PropTypes.bool,
}

export default LeadEditDropdownForNumberFields